/**
 * The two production Stripe prices of the Basic plan, abandoned by #744,
 * monthly then annual. The price list the UI resolves against only carries the
 * two Pro prices, so a seat or a history row on one of these would otherwise
 * read as "no licence" or "unknown plan".
 *
 * Copied from `api/src/common/constants/legacy-basic-price-ids.ts` rather than
 * shared: the API cannot import a runtime value from `@shaarp/common`, and the
 * only cost of a drift here is a label falling back to "unknown plan".
 */
const LEGACY_BASIC_PRICE_IDS: ReadonlyArray<string> = [
  "price_1PsOaZRvoFy4Tv24Jw5QEa0n",
  "price_1PsOaZRvoFy4Tv24128VZone",
];

/**
 * The billing frequency of a legacy Basic price, or null when `priceId` is not
 * one of them.
 */
export const legacyBasicFrequency = (
  priceId: string
): "monthly" | "annual" | null => {
  const index = LEGACY_BASIC_PRICE_IDS.indexOf(priceId);
  if (index < 0) return null;
  return index === 0 ? "monthly" : "annual";
};
